export const artifactName = 'payments-cc-form';
export const artifactId = `com.wixpress.${artifactName}`;
